import { TFunction } from 'i18next'
import { z } from 'zod'

import {
  importedInvoiceReviewFormShapeSchema,
  importedInvoiceReviewLineSchema,
} from '../types/importedInvoiceReviewFormSchema'

const REFERENCE_NUMBER_MAX_LENGTH = 64

/**
 * The approve contract: the review values approve can send. Expects the empty lines to be dropped
 * already. A client without an id is only the extracted name, so it does not count as picked.
 */
export const getImportedInvoiceReviewApprovableSchema = (t: TFunction) => {
  const requiredMessage = t('imported_invoices.review.form.validation.required')
  const selectClientMessage = t('imported_invoices.review.form.validation.select_client')
  /* eslint-disable @typescript-eslint/naming-convention -- zod's error option keys are snake_case */
  const required = { invalid_type_error: requiredMessage, required_error: requiredMessage }
  const selectClient = { invalid_type_error: selectClientMessage, required_error: selectClientMessage }
  /* eslint-enable @typescript-eslint/naming-convention */

  const lineSchema = importedInvoiceReviewLineSchema.extend({
    amountExclVat: z.number(required),
    categoryId: z.string(required),
    vatRateId: z.string(required),
  })

  return importedInvoiceReviewFormShapeSchema.extend({
    client: z.object(
      { id: z.string(selectClient).min(1, selectClientMessage), name: z.string().optional() },
      selectClient,
    ),
    currency: z.string(required),
    issueDate: z.date(required),
    lines: z.array(lineSchema).min(1),
    referenceNumber: z
      .string()
      .trim()
      .min(1, requiredMessage)
      .max(
        REFERENCE_NUMBER_MAX_LENGTH,
        t('imported_invoices.review.form.validation.max_length', { count: REFERENCE_NUMBER_MAX_LENGTH }),
      ),
  })
}
